var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1IntercomKeypad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 18a4.18 4.18 0 00-4-4H17a4.18 4.18 0 00-4 4v42a4.18 4.18 0 004 4h42a4.18 4.18 0 004-4V18zm-4 42H17V18h42v42zm-6-6h-6v-6h6v6zm0-12h-6v-6h6v6zm0-12h-6v-6h6v6zM41 54h-6v-6h6v6zm0-12h-6v-6h6v6zm0-12h-6v-6h6v6zM29 54h-6v-6h6v6zm0-12h-6v-6h6v6zm0-12h-6v-6h6v6z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Intercom_keypad.624eea18.svg";
export { SvgG1IntercomKeypad as ReactComponent };